export const defaultConfigColunas = [
  { nome: "idLote", exibir: true },
  { nome: "usuario", exibir: true },
  { nome: "reciboNf", exibir: true },
  { nome: "beneficiario", exibir: true },
  { nome: "custosDescricao", exibir: true },
  { nome: "processos", exibir: true },
  { nome: "totalAPagar", exibir: true },
  { nome: "valorCustos", exibir: true },
  { nome: "aReceber", exibir: true },
  { nome: "observacao", exibir: true },
];
